import { ROUTE_HOMEPAGE, ROUTE_WELCOME_JOURNEY } from './constants';

// The Welcome Journey page was removed in May 2025, but old e-mail and HubSpot
// links still open `/welcome-journey` (with or without a query string) and
// rendered NotFound. Send them to the dashboard instead. This redirect does not
// depend on VITE_WELCOME_JOURNEY_DISABLED (hubspot-off-block-3 task 93).
export const welcomeJourneyRedirectRoute = {
  path: ROUTE_WELCOME_JOURNEY,
  redirect: ROUTE_HOMEPAGE,
  exact: true,
};

export default welcomeJourneyRedirectRoute;
